module.exports = __webpack_public_path__ + "static/img/Logo5_RotaryClubOfBali.834a802.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logo5_RotaryClubOfBali.png
// module id = 318
// module chunks = 2